/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Laps_Legend_FasterInputs */

const en_ui_laps_legend_faster = /** @type {(inputs: Ui_Laps_Legend_FasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`faster than avg`)
};

const de_ui_laps_legend_faster = /** @type {(inputs: Ui_Laps_Legend_FasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`schneller als Ø`)
};

/**
* | output |
* | --- |
* | "faster than avg" |
*
* @param {Ui_Laps_Legend_FasterInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_laps_legend_faster = /** @type {((inputs?: Ui_Laps_Legend_FasterInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Laps_Legend_FasterInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_laps_legend_faster(inputs)
	return de_ui_laps_legend_faster(inputs)
});